// Central definitions for card icons and types
export const CARD_ICONS = [
  'glasses', 'hat', 'scroll', 'owl', 'letter',
  'timeturner', 'wand', 'beer', 'book', 'golden-snitch', 
  'cauldron', 'scarf', 'hogwarts-crest', 'potion'
];

// Map of card type IDs to their names for consistent references and logging
export const CARD_TYPE_NAMES: Record<number, string> = {
  0: 'glasses', 1: 'hat', 2: 'scroll', 3: 'owl', 4: 'letter',
  5: 'timeturner', 6: 'wand', 7: 'beer', 8: 'book', 9: 'golden-snitch', 
  10: 'cauldron', 11: 'scarf', 12: 'hogwarts-crest', 13: 'potion'
};

export const TOTAL_CARD_TYPES = CARD_ICONS.length; 